export default "__VITE_ASSET__DHYZ48DC__"